import { FrPageFooter } from '../../fr-page-layout/fr-page-footer';
import { useIntegratedForm } from '../../forms/use-integrated-form';
import { BoloPanelFormType } from '../../../../../../api-ts-packages/cad-api';
import { useFormState } from 'react-hook-form';
import { countDirtyFields } from '../../event-panel/count-dirty-fields';
import { ExpireAndReactivateBoloButton } from '../../bolos/bolo-panel/panel-components/expire-and-reactivate-bolo-button';
import { cssVar, HStack } from '@cad-arc';
import { FormSaveButton } from '../../forms/integrated-form-components/form-save-button';

export const FrBoloPageFooter = () => {
    const boloForm = useIntegratedForm<BoloPanelFormType>();

    const { dirtyFields } = useFormState({
        control: boloForm.form.control,
    });
    const dirtyFieldCount = countDirtyFields(dirtyFields);

    return (
        <FrPageFooter
            customStyles={{ justifyContent: 'flex-end', zIndex: cssVar('arc.zIndices.banner') }}
        >
            <HStack w="100%" justifyContent="space-between">
                <ExpireAndReactivateBoloButton />
                {dirtyFieldCount < 0 && (
                    <FormSaveButton size="lg" onClick={boloForm.onSubmit}>
                        Save
                    </FormSaveButton>
                )}
            </HStack>
        </FrPageFooter>
    );
};
